import { useSelector } from "react-redux";

import type { ICrmCustomFiltersListViewModel } from "app/pages/sales-intelligence/modules/crm-integration/types/filters-view-model";
import { selectActivePageTab } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";

import type { LeadsCapability } from "../types/leadsCapability";

import { useComputeCrmFiltersConfig } from "./useComputeCrmFiltersConfig";
import { useCrmFiltersReset } from "./useCrmFiltersReset";
import { useCrmScopeAutoSwitchNotification } from "./useCrmScopeAutoSwitchNotification";

export const useCrmFilters = (
    crmCustomFiltersListViewModel: ICrmCustomFiltersListViewModel,
    grants: ReadonlySet<LeadsCapability>,
) => {
    const activeTab = useSelector(selectActivePageTab);

    useCrmFiltersReset(crmCustomFiltersListViewModel.state !== "hidden");
    useCrmScopeAutoSwitchNotification();

    return useComputeCrmFiltersConfig(crmCustomFiltersListViewModel, { grants });
};
